import React from 'react';
import Popup from '@components/Popup';
import styles from './index.module.css';
import { popupImgSrcContent } from './constansts';
const MaleTextContent = () => {
  return (
    <div>
      通常より<strong>迅速</strong>な対応で、BLACKのお客様に限り
      <strong>電話対応</strong>も可能になります！
    </div>
  );
};
const FemaleTextContent = () => {
  return (
    <div>
      <strong>通常より迅速</strong>
      な対応で、お客様のデートをサポートさせていただきます！
    </div>
  );
};
const BlackUserConciergePopup = ({ isVisible, isMale, onPositiveClicked }) => {
  return (
    <Popup
      TitleComponent={
        <div className={styles.popupTitle}>
          <div>ブラック会員様</div>
          <div>専用コンシェルジュのご案内</div>
        </div>
      }
      visible={isVisible}
      MessagesComponent={
        <div className={styles.blackUserConciergerContainer}>
          <div className={styles.blackUserConciergerImgWrap}>
            <img
              src={isMale ? popupImgSrcContent.Male : popupImgSrcContent.Female}
              className={styles.blackUserConciergerImg}
              alt=""
            />
          </div>
          <div className={styles.blackUserConciergerText}>
            {isMale ? <MaleTextContent /> : <FemaleTextContent />}
          </div>
        </div>
      }
      positiveButtonTitle={'LINEを追加する'}
      positiveButtonClassName={styles.positiveButtonClassName}
      onPositiveClicked={onPositiveClicked}
      disableClose
    />
  );
};
export default BlackUserConciergePopup;
